





















import {Component, Prop, Vue} from 'vue-property-decorator';
import {ContactType} from '@/features/contacts/models/contactType';
import MultiSelectPicker from '@/shared/components/MultiSelectPicker.vue';

@Component({
	components: {
		MultiSelectPicker
	}
})
export default class MultiContactTypePicker extends Vue {
	@Prop() public value: ContactType[];

	public typeOptions: TypeOption[] = this.toOptionObjects([ContactType.Visitor, ContactType.Lead, ContactType.User]);
	public selectedOptions: TypeOption[] = [];

	public mounted() {
		if (this.shouldAllTypesBeSelected(this.value)) {
			this.selectedOptions = this.toOptionObjects([ContactType.Visitor, ContactType.Lead, ContactType.User]);
		} else {
			this.selectedOptions = this.toOptionObjects(this.value);
		}
	}

	public onInput(newSelectedOptions: TypeOption[]) {
		this.selectedOptions = newSelectedOptions;
		const selectedTypes = newSelectedOptions.map(option => option.type);
		this.$emit('updated-type', selectedTypes);
	}

	public get displayName() {
		if (this.selectedOptions.length === 0 || this.selectedOptions.length === 3) {
			return 'Visitors, Leads, Users';
		} else {
			return this.selectedOptions.map(option => this.getFriendlyName(option.type)).join(', ');
		}
	}

	private toOptionObjects(options: string[]): TypeOption[] {
		return options.map(type => ({ type, display: this.getFriendlyName(type) }));
	}

	private getFriendlyName(type: string) {
		return type.charAt(0).toUpperCase() + type.slice(1) + 's';
	}

	private shouldAllTypesBeSelected(types: string[]) {
		return !types || types.length === 0;
	}
}

interface TypeOption {
	type: string;
	display: string;
}
